import { useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, ArrowRight, MessageCircle, FileText, Users } from "lucide-react";

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const preferenceId = searchParams.get('preference_id');
    const externalReference = searchParams.get('external_reference');
    
    if (preferenceId && externalReference) {
      console.log('Payment confirmed:', { preferenceId, externalReference });
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-6">
      <Card className="max-w-lg w-full card-soft" data-testid="payment-success-card">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 bg-[#8FA38F] rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-white" />
          </div>
          
          <h1 className="font-serif text-3xl text-[#4A4036] mb-4">
            ¡Pago exitoso!
          </h1>
          
          <p className="text-lg text-[#786C60] mb-8">
            Tu inscripción a Tertulias Literarias ha sido confirmada. Bienvenida al club.
          </p>
          
          <div className="bg-[#FDFBF7] rounded-xl p-6 mb-8">
            <h3 className="font-semibold text-[#4A4036] mb-4">Próximos pasos:</h3>
            <div className="space-y-4 text-left">
              <div className="flex items-start gap-3">
                <MessageCircle className="w-5 h-5 text-[#25D366] flex-shrink-0 mt-1" />
                <p className="text-[#786C60]">Te enviaremos el link de WhatsApp en las próximas horas</p>
              </div>
              <div className="flex items-start gap-3">
                <FileText className="w-5 h-5 text-[#C47F68] flex-shrink-0 mt-1" />
                <p className="text-[#786C60]">Recibirás la guía de lectura del mes por email</p>
              </div>
              <div className="flex items-start gap-3">
                <Users className="w-5 h-5 text-[#8FA38F] flex-shrink-0 mt-1" />
                <p className="text-[#786C60]">La primera tertulia será anunciada en el grupo</p>
              </div>
            </div>
          </div>
          
          <Link to="/">
            <Button className="btn-primary w-full" data-testid="back-home-btn">
              Volver al inicio
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
